import { NgModule } from '@angular/core';
import { LibWorkReportSearchIconComponent } from './lib-workreport-search-icon.component';

@NgModule({
  declarations: [LibWorkReportSearchIconComponent],
  imports: [],
  exports: [LibWorkReportSearchIconComponent],
})
export class LibWorkReportSearchIconModule {}
